import {sortBy} from 'lodash';

export function condenseResults(options, results, condenseOptions, otherLabel = 'Other') {
    if (condenseOptions) {
        const sortedResults = sortBy(results, r => -1 * r.value);

        options = [...options];

        let otherResult = 0;
        for (let i = 0; i < condenseOptions && sortedResults.length > 0; ++i) {
            const last = sortedResults.pop();
            otherResult += last.value;
        }

        return [
            [...sortedResults.map(res => options.find(option => option.id == res.id)), {id: 'other', label: otherLabel}],
            [
                ...sortedResults,
                {
                    id: 'other',
                    value: otherResult,
                },
            ],
        ];
    }
    return [options, results];
}
